import { ChartOverlaysBorder } from '../../../core/components/overlays/ChartOverlaysBorder.js';

export const CategoricalBarChartOverlaysBorder = () => (
  <ChartOverlaysBorder left bottom />
);
